import React from "react";
import { Button, Stack } from "@mui/material";

export default function StepActions({ onNext, nextDisabled }) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      className="pt-2"
    >
      <Button
        variant="contained"
        onClick={onNext}
        className={`rounded-full px-10 md:px-24 py-2 shadow-none ${
          nextDisabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
        size="large"
        sx={{
          backgroundColor: "#1A85C1",
          "&:hover": {
            backgroundColor: nextDisabled ? "#1A85C1" : "#2563eb",
          },
          textTransform: "none",
        }}
      >
        Next
      </Button>
    </Stack>
  );
}
